import {
    getApiBarberProfileQueryKey,
    getApiBarberShiftIdQueryKey,
    getApiBarberShiftsAvailableSlotsQueryKey,
    getApiBarberShiftsBookedQueryKey,
    usePostApiBarberShiftEnd,
} from '@barbershop/api/barber'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { FORMATTED_TODAY_DATE, FORMATTED_TOMORROW_DATE } from '../../model/constants'

export const useEndCurrentShift = (shiftId: number) => {
    const queryClient = useQueryClient()

    const { mutateAsync: endCurrentShift, isPending } = usePostApiBarberShiftEnd({
        mutation: {
            onSuccess: async () => {
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberShiftsBookedQueryKey({
                            from: FORMATTED_TODAY_DATE,
                            to: FORMATTED_TOMORROW_DATE,
                        }),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberShiftsAvailableSlotsQueryKey({
                            from: FORMATTED_TODAY_DATE,
                            to: FORMATTED_TOMORROW_DATE,
                        }),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberShiftIdQueryKey(shiftId),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberProfileQueryKey(),
                    }),
                ])
                toast.success('Смена успешно завершена')
            },
            onError: () => {
                toast.error('Ошибка при завершении смены')
            },
        },
    })

    return {
        endCurrentShift,
        isPending,
    }
}
